<template>
  <v-container>
    <v-img height="250" contain :src="require('../assets/washi.png')">
    </v-img>
    <div class="text-md-center">
      {{nickname}}
    </div>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      name: "のび",
      nickname: "のびしこ"
    })
  }
</script>

<style>
  .text-md-center{
    text-align: center;
    font-weight: bold;
  }
</style>